import React, { useState, useEffect } from 'react';
import TreasureMap from '../projects/our-la-story/components/TreasureMap';
import PuzzleModal from '../projects/our-la-story/components/PuzzleModal';
import FinalReveal from '../projects/our-la-story/components/FinalReveal';
import IntroScreen from '../projects/our-la-story/components/IntroScreen';
import PhotoStrip from '../projects/our-la-story/components/PhotoStrip';
import MagicCursor from '../projects/our-la-story/components/MagicCursor';
import { STOPS } from '../projects/our-la-story/data/stops';
import '../projects/our-la-story/App.css';

function OurStory() {
  const [started, setStarted] = useState(false);
  const [currentStop, setCurrentStop] = useState(0);
  const [solvedStops, setSolvedStops] = useState([]);
  const [activePuzzle, setActivePuzzle] = useState(null);
  const [showReward, setShowReward] = useState(null);
  const [showFinal, setShowFinal] = useState(false);

  // Debug shortcut: press ` (backtick) to skip current puzzle
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === '`') {
        e.preventDefault();
        if (!started) {
          setStarted(true);
          return;
        }
        if (showFinal) return;
        if (showReward !== null) {
          const solvedIndex = showReward;
          const newSolved = [...solvedStops, solvedIndex];
          setSolvedStops(newSolved);
          setShowReward(null);
          if (newSolved.length === STOPS.length) {
            setTimeout(() => setShowFinal(true), 100);
          } else {
            setCurrentStop(solvedIndex + 1);
          }
        } else if (currentStop < STOPS.length) {
          setActivePuzzle(null);
          setShowReward(currentStop);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [started, currentStop, solvedStops, showReward, showFinal]);

  const handleStopClick = (index) => {
    if (index !== currentStop) return;
    if (solvedStops.includes(index)) return;
    setActivePuzzle(index);
  };

  const handlePuzzleSolved = () => {
    setShowReward(activePuzzle);
    setActivePuzzle(null);
  };

  const handleRewardDismiss = () => {
    const solvedIndex = showReward;
    const newSolved = [...solvedStops, solvedIndex];
    setSolvedStops(newSolved);
    setShowReward(null);

    if (newSolved.length === STOPS.length) {
      setTimeout(() => setShowFinal(true), 600);
    } else {
      setCurrentStop(solvedIndex + 1);
    }
  };

  const handleClosePuzzle = () => {
    setActivePuzzle(null);
  };

  if (!started) {
    return (
      <div className="our-story-page">
        <MagicCursor />
        <IntroScreen onStart={() => setStarted(true)} />
      </div>
    );
  }

  if (showFinal) {
    return (
      <div className="our-story-page">
        <MagicCursor />
        <FinalReveal />
      </div>
    );
  }

  return (
    <div className="our-story-page">
      <MagicCursor />
      <div className="App our-story-app">
      <div className="map-header">
        <h1 className="map-title">Our LA Story</h1>
        <p className="map-clue">
          {currentStop < STOPS.length
            ? STOPS[currentStop].clue
            : 'All clues solved!'}
        </p>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(solvedStops.length / STOPS.length) * 100}%` }}
          />
        </div>
        <p className="progress-text">{solvedStops.length} / {STOPS.length} discovered</p>
      </div>

      <TreasureMap
        stops={STOPS}
        currentStop={currentStop}
        solvedStops={solvedStops}
        onStopClick={handleStopClick}
      />

      {activePuzzle !== null && (
        <PuzzleModal
          stop={STOPS[activePuzzle]}
          onSolved={handlePuzzleSolved}
          onClose={handleClosePuzzle}
        />
      )}

      {showReward !== null && (
        <div className="reward-overlay" onClick={handleRewardDismiss}>
          <div className={`reward-card ${STOPS[showReward].reward.photos ? 'reward-card-wide' : ''}`} onClick={(e) => e.stopPropagation()}>
            {STOPS[showReward].reward.photos && STOPS[showReward].reward.photos.length > 0 && (
              <div className="reward-strip-left">
                <PhotoStrip
                  photos={STOPS[showReward].reward.photos}
                  side="left"
                />
              </div>
            )}
            <div className="reward-center">
              <div className="reward-sparkle">✨</div>
              <h2 className="reward-title">Unlocked: {STOPS[showReward].reward.title || STOPS[showReward].name}!</h2>
              {STOPS[showReward].reward.photo && !STOPS[showReward].reward.photos && (
                <img
                  src={STOPS[showReward].reward.photo}
                  alt={STOPS[showReward].name}
                  className="reward-photo"
                />
              )}
              <p className="reward-message">{STOPS[showReward].reward.message}</p>
              <button className="reward-btn" onClick={handleRewardDismiss}>
                →
              </button>
            </div>
            {STOPS[showReward].reward.photos && STOPS[showReward].reward.photos.length > 0 && (
              <div className="reward-strip-right">
                <PhotoStrip
                  photos={STOPS[showReward].reward.photos}
                  side="right"
                />
              </div>
            )}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default OurStory;
